import { createRouter, createWebHistory } from 'vue-router'

// Route components are lazy-loaded so the main chat bundle doesn't grow with
// the RAG portal (and vice versa).
const Home = () => import('./App.vue')
const RAGShell = () => import('./components/RAGShell.vue')
const RAGPortal = () => import('./components/RAGPortal.vue')
const RAGWelcome = () => import('./components/RAGWelcome.vue')
const RAGCreateWizard = () => import('./components/RAGCreateWizard.vue')
const RAGSettingsView = () => import('./components/RAGSettingsView.vue')
const RAGVersionsView = () => import('./components/RAGVersionsView.vue')
const RAGTestingView = () => import('./components/RAGTestingView.vue')
const RAGTestRunResults = () => import('./components/RAGTestRunResults.vue')
const RAGSMEInbox = () => import('./components/RAGSMEInbox.vue')
const RAGCompareView = () => import('./components/RAGCompareView.vue')
const RAGConversationsView = () => import('./components/RAGConversationsView.vue')
const RAGAclDiagnostic = () => import('./components/RAGAclDiagnostic.vue')
const RAGImportWizard = () => import('./components/RAGImportWizard.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },

  // RAG Studio — RAGShell wraps every /rag/* route with the persistent
  // sidebar + topbar; children render inside its <router-view />.
  {
    path: '/rag',
    component: RAGShell,
    children: [
      // Bare /rag: the shell decides whether to render the welcome panel
      // (zero instances) or redirect to /rag/<last>/settings (>0). The
      // RAGPortal grid is reachable via "View all instances" in the
      // dropdown footer; mounted at /rag/all so the redirect logic on
      // /rag itself stays clean.
      { path: '', name: 'rag-welcome', component: RAGWelcome },
      { path: 'all', name: 'rag-portal', component: RAGPortal },
      { path: 'new', name: 'rag-new', component: RAGCreateWizard },
      { path: 'import', name: 'rag-import', component: RAGImportWizard },
      { path: 'review', name: 'rag-sme-inbox', component: RAGSMEInbox },
      // Staff-only ACL diagnostic — answers "what docs can user X see?".
      // Permission is enforced server-side; the sidebar only renders the
      // entry point for is_staff users, but a direct URL hit still works
      // for admins typing it manually.
      { path: 'admin/acl-lookup', name: 'rag-acl-diagnostic', component: RAGAclDiagnostic },
      // More specific static segments before /:id so /rag/runs/<uuid>
      // doesn't resolve as an instance id.
      { path: 'runs/:id', name: 'rag-test-run', component: RAGTestRunResults, props: true },
      { path: ':id/settings', name: 'rag-settings', component: RAGSettingsView, props: true },
      { path: ':id/versions', name: 'rag-versions', component: RAGVersionsView, props: true },
      { path: ':id/testing', name: 'rag-testing', component: RAGTestingView, props: true },
      { path: ':id/conversations', name: 'rag-conversations', component: RAGConversationsView, props: true },
      { path: ':id/compare', name: 'rag-compare', component: RAGCompareView, props: true },
      // Bare /rag/:id → settings tab.
      { path: ':id', redirect: (to) => `/rag/${to.params.id}/settings` },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
